// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page-carousel-tab {
  .slick-dotted.slick-slider {
    margin-bottom: 12px;
  }

  .slick-dots {
    bottom: -30px;
  }

  @media screen and (max-width: 468px) {
    .slick-dots li {
      margin: 0 1px !important;
    }
  }

  @media screen and (min-width: 468px) {
    .slick-dots li button:before {
      font-size: 11px;
    }
  }
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
